var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(166, 57, 35)",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "79") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Compound Path",
    d: "M22.7,7.4A13.1,13.1,0,0,0,9.6,20.5V61.4H5.5a3,3,0,0,0,0,6H9.8a28.2,28.2,0,0,0,28,25.3H63.3a28.2,28.2,0,0,0,28-25.3h3.2a3,3,0,0,0,0-6H15.6V20.5a7.1,7.1,0,0,1,14.2,0v2a12.1,12.1,0,0,0-9.6,11.9,3,3,0,0,0,3,3H42.4a3.1,3.1,0,0,0,3-3.1,12,12,0,0,0-9.6-11.8v-2A13.1,13.1,0,0,0,22.7,7.4ZM63.3,86.6H37.7A22.2,22.2,0,0,1,15.8,67.4H85.2A22.2,22.2,0,0,1,63.3,86.6ZM38.7,31.3H27a6,6,0,0,1,5.2-3.1h1.2A6,6,0,0,1,38.7,31.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Path",
    x: 29.8,
    y: 40.6,
    width: 6,
    height: 11.48
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Path",
    x: 38.9,
    y: 40.6,
    width: 6,
    height: 11.48
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Path",
    x: 20.7,
    y: 40.6,
    width: 6,
    height: 11.48
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.564716067e16093fe7c2a6c497ea3392.svg";
export { ForwardRef as ReactComponent };